import { useMemo } from 'react';
import { Box } from '~/commonComponents/Box';
import { IRecommendedProfessional } from '~/domain/RecommendedProfessionals';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { NoNewToYou } from './NoNewToYou';

export const RecommendedProsTabPanel = ({
  isLoading,
  selectedProfessionals,
  onSelectProfessionals,
  profession,
  data = [],
  isNewDesign,
  onViewSkills,
  sentProfessionalIds,
  jobId,
}: IProfessionalTabPanelProps<IRecommendedProfessional>) => {
  const professionals = useMemo(() => {
    return data?.map(
      (it) =>
        ({
          full_name: it.fullName,
          id: it.id,
          isAvailable: it?.isAvailable ?? true,
          profile_image: it.profileImage,
          professions: it.professions,
          rating: {
            averageRating: it.rating,
            professionalSkills: it.averageProfessionalSkills,
            interpersonalSkills: it.averageInterpersonalSkills,
            timeManagement: it.averageTimeManagement,
          },
          badges: it.badges ?? [],
          education: it.education ?? {},
        }) as unknown as IRecommendedProfessional,
    );
  }, [data]);

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Box flex={1}>
      <ProfessionalList
        DescriptionComponent={
          <>
            Reliable professionals, trusted by nearby offices. They&apos;ll be
            <br />
            confirmed if they accept your offer as posted.
          </>
        }
        EmptyComponent={<NoNewToYou />}
        isEmpty={isEmpty}
        isLoading={isLoading}
        // @ts-expect-error -- Wrong type
        professionals={professionals}
        selectedProfessionals={selectedProfessionals}
        selectedProfession={profession}
        onSelectProfessionals={onSelectProfessionals}
        isNewDesign={isNewDesign}
        onViewSkills={onViewSkills}
        sentProfessionalIds={sentProfessionalIds}
        jobId={jobId}
      />
    </Box>
  );
};
